import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Process, General } from '../redux/action/action';
import BannerFront from '../assets/images/banner-front.png';
import ProgramsComponent from '../components/ProgramsComponent';
import { Tools } from '../utils/tools';

const mapStateToProps = (props) => { return { glo: props.general, pro: props.process } }
const mapDispatchToProps = (dispatch) => { return { general: (global) => dispatch(General(global)), process: (user) => dispatch(Process(user)) } }

class InterestProgramPage extends Component {
    constructor(props) {
        super(props);

        this.state = {
            platform: Tools.platformDevice()
        }
    }

    componentDidMount() {
        let _root = this;
        if (!_root.props.glo.isLogin) { window.location.href = '/'; }
    }

    render() {
        const {
            platform
        } = this.state;

        return (
            <>
                <div className="container">
                    <div className="row app-layout-main">
                        {(platform === 'web') &&
                            <div className="col-sm-12 col-md-4" style={{ backgroundImage: 'url(' + BannerFront + ')', backgroundSize: 'cover', backgroundRepeat: 'no-repeat' }}></div>
                        }
                        <div className="col-sm-12 col-md-8 right-side-main">
                            <ProgramsComponent navigate={this.props.navigate} />
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(InterestProgramPage);